<template>
    <div :id="`faq-${id}`" ref="container" class="scc-faq-item" :class="{ 'scc-faq-item--active': active }">
        <div class="scc-faq-item-question">
            {{ question }}
            <arrowDown class="scc-faq-item-icon" />
        </div>
        <div ref="answer" class="scc-faq-item-answer">
            {{ answer }}
        </div>
    </div>
</template>

<script>
import './faq-item.scss';
import arrowDown from '../../assets/icons/arrow-down.vue';

export default {
    name: 'FaqItem',
    components: { arrowDown },
    props: {
        id: {
            type: String,
            required: true,
        },
        question: {
            type: String,
            required: true,
        },
        answer: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            active: false,
        };
    },
    mounted() {
        this.addSlideDownAnimation();
    },
    methods: {
        addSlideDownAnimation() {
            let { container, answer } = this.$refs;
            let self = this;
            container.addEventListener('click', function() {
                self.active = !self.active;
                let panel = answer;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });
        },
    },
};
</script>
